import * as React from "react";
const SVGComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="pt-5" viewBox="0 0 1440 316" {...props}>
    <defs>
      <clipPath id="clip-path">
        <path
          style={{
            fill: "none",
          }}
          d="M0 0h1440v316H0z"
        />
      </clipPath>
      <style>{".cls-6{fill:#fa786f}"}</style>
      {/* <mask
        id="mask"
        x={-668.77}
        y={-183.03}
        width={2154.04}
        height={821.89}
        maskUnits="userSpaceOnUse"
      >
        <path
          d="M-2 557h1444v-740H-2Z"
          style={{
            fill: "#fff",
          }}
          id="mask0_97_2859"
          data-name="mask0 97 2859"
        />
      </mask> */}
    </defs>
    <g id="Calque_2" data-name="Calque 2">
      <g
        style={{
          opacity: 0.2,
        }}
        id="Calque_1-2"
        data-name="Calque 1"
      >
        <g
          style={{
            clipPath: "url(#clip-path)",
          }}
        >
          <g
            style={{
              mask: "url(#mask)",
            }}
          >
            <path
              className="cls-6"
              d="M-668.77 150.36v40h24.61v18.38l-19.16 1v18.37h-5.45v410.76h2154v-449h-19.41v-19.75h-20V151h-19v18.62H1407V151h-39.21v38.05h-38.87v-18.6h-39.34v-18.83h-58.6v37.56h-39.06v-18.73h-19V209h18.79v19.11h-38.56v-57.58h-19.24V190h-19.54v38.08h-19.85V190h-19.85v-38.54h-38.13c-.33 6.43-.67 12.34-1 18.22h-19.61v-18.17h-19.32v18.74h-19.08v-18.51h-39.75v18h-39.16V132h-19.26v38.54h-19.18l-.61 19.64h-38.75v-19.63H801.1v-39h-19v39.32h-39.47v37.9h-19.57V190H704v19.5h-39.1v18.63h-20v-18.6h-19.8v-19.21h-18.64c-.34 6.37-.65 12.3-1 18.29H586v-38.54h-18.6c-.34-6.61-.67-12.54-1-19.53h-19.19v-19h-19.85v18.76h-38.18c-.28-6.4-.57-12.31-.85-18.35h-78V190h-19.09v18.63H351.8v-38.18h-97.71V189h-38.26v-37.74l18.29-1v-18.84H196v77.24h-20.1v-38.54h-19v-38.19h-20.13V151h-19v38h-20v-18H58.68v18h-78.45v-37.64H-39v19.12h-19.1v19.71H-39v19h-39.47v-19.75h-58.26V150.9h-19.16v18.68h-58v-18.32H-195v-19.89h-58.42v58.2h-19.31v19h-20.08v-38.09h-19.9v18.78h-19.38v-18.78h-19.11v38.05h-39.6v-57.14h-19.56V189h-38.21v-37.8l18.18-.89v-18.2h-38.72V151h-19.29v19.07l-19.15.34v19.81h-20v18.47h-19.56v-19.4h-19.52v-38.06l-19.54-1v-18.84h-19.05v19.89h-20v18.3h-39.28v-19.22Zm2057 59.56h18.51v-19.63h19.57v18.55h38.57v19.27h-76.7Zm-78.63-.46h18.62v18.65h-18.67Zm-19.46-18.91h19.1v18.6h-19.15Zm-19 18.91h18.64v18.65h-18.7Zm-39.29 20.2h18.28v18.21h-18.33Zm-215.32-20.2h18.67v18.65h-18.67Zm-18.9-18.94h18.6v18.63h-18.6Zm-39.1-20.12h18.67v38.13h-18.69ZM957 229.5v18.32h-37.76V229.5Zm-97.08-38.95h77.75v18h-77.85Zm-77.27-.41h18v38h-18ZM704.39 249h18.16v18.34h-18.16Zm-175.95-77.93h19.24v18.5h18.51v19.17h-37.75Zm-.15 58.48h18.56v18h-18.56Zm-38.88-58.76h18.18v38.1h-18.18Zm-39.54.28h18.72v18.5h-18.72ZM430.38 190h19.13v19.14h-19.18Zm-19 19.45h18.69v18.65h-18.69Zm-97.71-19.17h18.2v18.19h-18.2Zm-39.06.2h18.16v18.35h-18.11ZM216 210.13h18.62v18H216Zm-78.15-39.83h18.69v18.76h-18.69Zm-97.53 39.16h17.85v18.65H40.32Zm-40.75 0v18.65h-38.16v-18.68Zm-116 .54h18.56v18h-18.56Zm-78.37-19.48h38.18v18.6h-38.18Zm-19 18.91h18.69v18.68h-18.72ZM-312 229h18.46v18.66h-18.59Zm-19-19h18.66v18.7H-331Zm-138.32-39.6v18.68H-488V170.4Zm-115.86 58.95H-567v38.13h-18.18Zm-39.49-39.27h18.82c.36-7 .67-12.85 1-19.32h18.31v38.39h-38.13Zm-19.24 19 18.93.38v18.68h-18.93Z"
            />
            <path
              className="cls-6"
              d="M664.82 190v-19.86l-.31.31h19.85v-19.84l-.31.31h19.39v-38.54H723v18.4h19.15v19.53l-18.56.95v18.63H703.6V190l.3-.31h-39.39Z"
            />
            <path
              className="cls-6"
              d="M625.41 111.58V151h39.41l-.31-.3v19.83l.31-.3h-58.47V131.7h-19V112h38.33Zm488.81 58.85v-38.55h38.72v18.89l.34-.28h-19.83v19.83l.31-.3h-19.85Zm-762.01.02v-38.54h38.34v18.35h-19.13v20.17l.33-.29H351.8Zm-78.81-39.08h19.47V150h-37.8v-37.72h18.33Zm547.73 39.08v-19h38.77v19l.31-.31h-39.39Zm352.13-19.17V131.8h38V151h-38.34Zm-1055.44-.64h-19v-38.16h18.67V151Zm1133.5-20.02V93h18.41v37.62Zm-196.08-18.14v18h-38.11v-18Zm-273.15 18.63H763.2V92.9h18.69v38.55Zm-136.81 78.4V190h19.54l-.31-.28v19.81l.31-.28h-19.9ZM1094.65 190v-19.57h19.57l-.33-.29V190l.3-.28h-19.85Zm-723.23-19.57H391V190l.3-.31h-19.55v-19.55Zm957.68.05v-18.94h18.69v18.63h-18.92Z"
            />
            <path
              className="cls-6"
              d="m1152.94 150.9 20.32.36-.34-.29c0 6.51-.28 13-.41 19.48l.31-.31H1153l.31.31v-19.84ZM19.37 169.86H1.11v-18.47h18.26ZM1407.26 151v-19.48h19.52l-.31-.31q.1 9.79.1 19.82l.31-.31H1407Zm-742.44 0v-18.91h19.23V151l.31-.31h-19.85Zm-624.93-.77V132h18.46v18.27Zm1386.89-18.81v-18.94h18.69v18.63h-18.9Zm-879.21 0v-18.94h18.7v18.63h-19.06ZM196 131.11h-19v-18.63h18.6v19Zm664.49-19.94V92.9h18.41v18.27Zm-234.78.72V93h18.72v18.63h-19ZM59.68 92.72H78v18.19H59.68Zm1133.09-19.58H1211v18.37h-18.18Zm-39.26 18.17v-18H1172v18ZM919.24 73.14h18.18v18.37h-18.18Zm-97.68 0h18.18v18.37h-18.18Zm-117.17-.28h18v18.58h-18Zm-273.65.23H449v18.47h-18.26ZM19.11 91.77H1V73.19h18.11Zm1348.32-19.3h-18v-18.6h18ZM136.33 52.71h-18V34.13h18Zm-57.59-.46V34.42h18.51v17.83Zm625.47-19.43V14.63h18.23v18.19Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SVGComponent;
